export default "__VITE_PUBLIC_ASSET__0f26ad3d__"